import apiClient from "./apiClient";

// ✅ Fetch all users based on type with pagination
export const fetchUsersAPI = (userType, page = 1) => {
  // userType: "pet-parents" or "veterinarians"
  const vendor = userType === "veterinarians" ? "true" : "false";
  return apiClient.get(`/tailmission/api/v1/admin/users?page=${page}&vendor=${vendor}`);
};

// ✅ Fetch a single user by ID
export const fetchUserByIdAPI = (userType, id) => {
  console.log('Fetching user:', { id });
  
  return apiClient.get(`/tailmission/api/v1/admin/users/${id}`);
};

// ✅ Delete a user by ID
export const deleteUserAPI = (userType, id) => {
  return apiClient.delete(`/tailmission/api/v1/admin/users/${id}`);
};

// ✅ Update a user by ID
export const updateUserAPI = (userType, id, data) => {
  // Check if data is FormData (for proper backend format)
  const isFormData = data instanceof FormData;

  const config = {
    headers: {
      ...(isFormData ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'application/json' })
    }
  };

  return apiClient.put(`/tailmission/api/v1/admin/users/${id}`, data, config);
};
